import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useContactoSaldoPendiente } from "api/Contacto.hook"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory, useParams } from "react-router-dom"
import { OPTIONS_DOC } from "../constants"
import { CONTACTO_TABS } from "../constants/constants"

export const SaldoPendiente = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const [selected, setSelected] = useState(false)
  const { FACTURAS } = CONTACTO_TABS
  const history = useHistory()
  const { saldoPendiente } = useContactoSaldoPendiente(id)
  const formatNumber = (number: number) => {
    return new Intl.NumberFormat("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(number)
  }
  const saldoPago = formatNumber(saldoPendiente?.saldoPago ?? 0)
  const saldoCobro = formatNumber(saldoPendiente?.saldoCobro ?? 0)
  const hasSaldoPendiente =
    saldoPendiente &&
    (saldoPendiente?.saldoPago > 0 || saldoPendiente?.saldoCobro > 0)

  return (
    <div className='tw-font-medium tw-text-left tw-pt-6'>
      <div className='tw-text-sm tw-text-text tw-pb-2'>
        {t("contactos.editar.saldos.headerSaldoPendiente")}
      </div>
      {!hasSaldoPendiente ? (
        <div className='tw-flex tw-items-center tw-border tw-border-info tw-bg-info-10 tw-text-sm tw-text-info tw-font-normal tw-rounded-md tw-px-4 tw-py-2 tw-mb-2'>
          <FontAwesomeIcon
            className='tw-text-text-hyperlinks tw-pr-3 tw-h-5'
            icon={["fas", "info-circle"]}
          />
          {t("contactos.editar.saldos.labelSaldoEmpty")}
        </div>
      ) : (
        <div className='tw-flex tw-flex-col tw-gap-3'>
          <div className='tw-shadow tw-rounded tw-flex tw-items-center tw-justify-between tw-text-sm tw-h-12 tw-px-4'>
            <div>
              <span className='tw-mr-1'>
                {t("contactos.editar.saldos.labelPago")}
              </span>
              <span className='tw-font-sm'>{`${saldoPago} €`}</span>
            </div>
            <FontAwesomeIcon
              onClick={() => {
                history.replace({
                  state: {
                    selectedTab: FACTURAS,
                    selectedSubTab: OPTIONS_DOC.COMPRA,
                    selectedTabFilters: {
                      estadoDePago: {
                        NoPagado: true,
                        Pagado: false,
                        ParcialmentePagado: true,
                      },
                    },
                    clicked: selected,
                  },
                })
                setSelected(!selected)
              }}
              className='tw-p-2 tw-text-text-hyperlinks tw-cursor-pointer'
              icon={["fal", "eye"]}
            />
          </div>

          <div className='tw-shadow tw-rounded tw-flex tw-text-sm tw-items-center tw-justify-between tw-h-12 tw-px-4'>
            <div>
              <span className='tw-mr-1'>
                {t("contactos.editar.saldos.labelCobro")}
              </span>
              <span className='tw-font-sm'>{`${saldoCobro} €`}</span>
            </div>
            <FontAwesomeIcon
              onClick={() => {
                history.replace({
                  state: {
                    selectedTab: FACTURAS,
                    selectedSubTab: OPTIONS_DOC.VENTA,
                    selectedTabFilters: {
                      estadoDePago: {
                        NoPagado: true,
                        Pagado: false,
                        ParcialmentePagado: true,
                      },
                    },
                    clicked: selected,
                  },
                })
                setSelected(!selected)
              }}
              className='tw-p-2 tw-text-text-hyperlinks tw-cursor-pointer'
              icon={["fal", "eye"]}
            />
          </div>
        </div>
      )}
    </div>
  )
}
